import { useLocation, useNavigate } from "react-router-dom";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import PageHeader from "../../../Component/BasicComponents/HeaderBreadCrumbs";
import RoundedDropdown from "../../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import { useMemo, useState } from "react";
import { useExpenseListDataAllUnit } from "../hooks/useExpense";
import { FaEye } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import {
  setMonth as setAuditMonthInRedux,
  resetFilter as resetFilterAduit,
  setAudit,
  setlimit,
  setPage,
} from "../../../ReduxToolkit/Reducers/Expense/auditSlice";
import { useHardRefresh } from "../../../Component/BasicComponents/Hooks/useHardRefresh";
import {
  resetDropDown,
  resetPagination,
} from "../../../ReduxToolkit/Reducers/Expense/EmployeeList_Slice";
import { useExcelPolling } from "../../../hooks/useExcelPolling";
import { showToast } from "../../../utils/toastUtils";
import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";
import { COLORS } from "../../../constants/colors";

const ExpAudit = () => {
  const { startPolling, stopPolling } = useExcelPolling();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { filter } = useSelector((state: any) => state.audit);
  const getLastSixMonths = (): { id: string; label: string }[] => {
    const months: { id: string; label: string }[] = [];
    const today = new Date();

    for (let i = 0; i < 12; i++) {
      const year = today.getFullYear();
      const month = today.getMonth() - i;
      const date = new Date(year, month, 1);
      const start = new Date(date.getFullYear(), date.getMonth(), 1);
      const end = new Date(date.getFullYear(), date.getMonth() + 1, 0);

      const startStr = start.toLocaleDateString("sv-SE");
      const endStr = end.toLocaleDateString("sv-SE");
      const label = `${date.toLocaleString("default", {
        month: "short",
      })} ${String(date.getFullYear()).slice(2)}`;
      months.push({
        id: `${startStr}|${endStr}`,
        label,
      });
    }

    return months;
  };

  const months = useMemo(() => getLastSixMonths(), []);
  const [selectedMonthYear, setSelectedMonthYear] = useState<any>(months[0]);
  const [auditScreenStatus, setAuditScreenStatus] = useState(true);
  const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
  const [excelStatus, setExcelStatus] = useState<string | null>("Loading..");
  useHardRefresh(() => dispatch(resetFilterAduit()));
  const expense = useExpenseListDataAllUnit({
    params: {
      unitName: "",
      month: filter.filter.month.id,
      start: filter.filter.page,
      length: filter.filter.limit,
      IsExpense: 0,
    },
    enable: !!filter.filter.month.id,
  });

  const expenseList = expense;

  const handleExpenseView = (row: any) => {
    dispatch(setAudit(true));
    navigate("/expense/expenses/employeeList", {
      state: {
        expenseList: JSON.parse(JSON.stringify(expenseList)),
        row: JSON.parse(JSON.stringify(row)),
        selectedMonthYear,
        auditScreenStatus,
      },
    });
    dispatch(resetPagination());
    dispatch(resetDropDown());
  };

  const expenseColumns = (handleExpenseView: (row: any) => void): any[] => [
    {
      name: "Business unit",
      selector: (row: { UnitName: number | string }) => row.UnitName,
      sortable: true,
      minWidth: "150px",
      headCells: {
        style: {
          "&:first-of-type": {
            position: "sticky",
            left: 0,
            backgroundColor: "#fff",
            zIndex: 3,
          },
        },
      },
      style: {
        position: "sticky",
        left: 0,
        backgroundColor: "#fff",
        zIndex: 3,
        borderRight: "1px solid #ddd",
      },
    },
    {
      name: "Employee requested",
      selector: (row: { requestCount: number; requestAmount: number }) =>
        `${row.requestCount} (₹${row.requestAmount.toLocaleString("en-IN")})`,
      sortable: true,
      minWidth: "200px",
    },
    {
      name: "Submitted",
      selector: (row: { submitCount: number; submitAmount: number }) =>
        `${row.submitCount} (₹${row.submitAmount.toLocaleString("en-IN")})`,
      sortable: true,
      minWidth: "200px",
    },
    {
      name: "Approved",
      selector: (row: {
        ExpenseApprovedCount: string;
        ExpenseApprovedAmtSum: number;
      }) =>
        `${
          row.ExpenseApprovedCount
        } (₹${row.ExpenseApprovedAmtSum.toLocaleString("en-IN")})`,
      sortable: true,
      minWidth: "180px",
    },
    {
      name: "Pending for Audit",
      selector: (row: { pendingCount: string; pendingAmount: number }) =>
        `${row.pendingCount} (₹${row.pendingAmount.toLocaleString("en-IN")})`,
      sortable: true,
      minWidth: "200px",
    },
    {
      name: "Hold",
      selector: (row: { holdCount: string; holdAmount: number }) =>
        `${row.holdCount} (₹${row.holdAmount.toLocaleString("en-IN")})`,
      sortable: true,
    },
    {
      name: "Payment",
      selector: (row: { paymentCount: string; paymentAmount: number }) =>
        `${row.paymentCount} (₹${row.paymentAmount.toLocaleString("en-IN")})`,
      sortable: true,
      minWidth: "150px",
    },
    {
      name: "Actions",
      cell: (row: any) => (
        <button
          onClick={() => handleExpenseView(row)}
          className="btn btn-primary"
          style={{
            borderRadius: "20px",
            padding: "5px",
            width: "80px",
            fontSize: "14px",
          }}
        >
          <FaEye size={14} style={{ fill: "#fff" }} /> View
        </button>
      ),
    },
  ];

  const handlePagination = (pageNo: number) => {
    dispatch(setPage(pageNo));
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    dispatch(setPage(pageNo));
    dispatch(setlimit(limit));
  };

  const handleMonthYear = (value: any) => {
    setSelectedMonthYear(value);
    dispatch(setAuditMonthInRedux(value));
  };

  console.log('filter.filter.month.id',filter.filter.month.id);
  const downoadExcel = async () => {
    const params: Record<string, any> = {
      ...{ month: filter?.month?.id == "" ? filter?.filter.month?.id : filter?.filter?.month?.id },
      ...{ IsExpense: 0 },
    };
    const queryString = new URLSearchParams(params).toString();

    try {
      setLoadingExcel(true);
      const response = await axiosInstance.get(
        `${API_ENDPOINTS.EXPENSE.GET_EXCEL_DOWNLOAD_UNITEXCEL}?${queryString}`
      );
      const { success, fileDownloadId, intervalTime } =
        response?.data?.data || null;
      if (success && fileDownloadId) {
        startPolling(fileDownloadId, intervalTime, {
          onStatusUpdate: (currentStatus: string) => {
            setExcelStatus(currentStatus);
          },
          onSuccess: (url: any) => {
            setLoadingExcel(false);
            setExcelStatus("Loading..");
            const a = document.createElement("a");
            a.href = url;
            a.download = "report.xlsx";
            a.click();
            showToast.success("The file is ready!");
          },
          onFailed: (msg: any) => {
            showToast.error(msg || "");
            stopPolling();
            setLoadingExcel(false);
          },
          onExpired: (msg: any) => {
            showToast.error(msg || "");
            stopPolling();
            setLoadingExcel(false);
          },
          onDeleted: (msg: any) => {
            showToast.error(msg || "");
            stopPolling();
            setLoadingExcel(false);
          },
        });
      }
    } catch (error: any) {
      showToast.error(error);
      console.log("Something Went Wrong inDownLoad Excel", error);
    }
  };

  return (
    <div className="p-2" style={{ maxWidth: "100%" }}>
      <PageHeader
        title="Audit"
        buttons={[
          {
            label: loadingExcel
              ? excelStatus
                ? excelStatus.charAt(0).toUpperCase() +
                  excelStatus.slice(1) +
                  "..."
                : ""
              : "Excel",
            onClick: () => downoadExcel(),
            color: loadingExcel ? COLORS.disable : COLORS.primary,
            disable: loadingExcel ? true : false,
          },
        ]}
      />

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          margin: "auto",
          marginTop: "2%",
        }}
      >
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <BasicDataTable
            customStyle={{
              headCells: {
                style: {
                  fonstSize: 14,
                  fontWeight: "bold",
                  zIndex: 2,
                  "&:first-of-type": {
                    position: "sticky",
                    left: 0,
                    zIndex: 3,
                    background: "#fff",
                  },
                },
              },
              head: {
                style: {
                  backgroundColor: "red",
                  zIndex: 4,
                },
              },
            }}
            Title="Business unit summary"
            dynamicHeightOnRowsPerPage={true}
            paginationTotalRows={expenseList?.data?.data?.recordsTotal || 0}
            onChangePage={(pageNo: number) => {
              handlePagination(pageNo);
            }}
            onChangeRowsPerPage={(newPerPage: any, page: any) => {
              handleonChangeRowsPerPage(newPerPage, page);
            }}
            search={false}
            columns={expenseColumns(handleExpenseView)}
            data={expenseList?.data?.data?.data || []}
            headerContent={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "10px",
                  marginBottom: "15px",
                }}
              >
                <RoundedDropdown
                  key={filter?.filter?.month?.label}
                  options={months}
                  onSelect={(value: string) => handleMonthYear(value)}
                  defaultLabel={
                    filter?.filter?.month?.label === ""
                      ? months[0].label
                      : filter?.filter?.month.label
                  }
                  width="150px"
                  isShowHeading
                  DropdownHeading="Month & Year"
                  headingColor="#2e8dd3"
                />
              </div>
            }
          />
        </div>
      </div>
    </div>
  );
};

export default ExpAudit;
